export const APP_VERSION = {
  version: '1.1.24',
  buildDate: '2026-04-29T08:13:59.804Z',
  commitHash: 'N/A'
};
